import CookieAccordion from './CookieAccordion';

export default CookieAccordion;
